module.exports = __webpack_public_path__ + "static/media/mail-icon.d25c676d.svg";